<template>
  <van-nav-bar
    :title="title"
    left-text=""
    :right-text="rightText"
    :left-arrow="leftArrow"
    :fixed="true"
    :class="themeClass"
    :border="false"
    @click-left="onClickLeft"
    @click-right="onClickRight"
  />
</template>
<script>
export default {
  props: {
    themeClass: {
        default: 'self-nav',
        type: String
    },
    title: {
        default: '企管车',
        type: String
    },
    leftArrow: {
      default: true,
      type: Boolean,
    },
    rightText: {
      default: "",
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    onClickLeft(){
        this.$router.back()
    },
    onClickRight(){
        this.$emit('onClickRight')
    }
  },
};
</script>
<style lang="scss" scoped>
.self-nav {
    background-color: #266EFF;
    ::v-deep .van-nav-bar__title {
        color: #fff;
    }
    ::v-deep .van-icon{
        color: #fff;
    }
    ::v-deep .van-nav-bar__text{
        color: #fff;
    }
}
</style>